import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import { Label } from '../componentes_generales/componentes_formulario/labels/';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit} from '../componentes_generales/componentes_formulario/contenedores/';
import { Field, reduxForm , formValueSelector  } from 'redux-form';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import { connect } from 'react-redux';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { cargar_GastosImportacion } from '../../actions/importaciones/act_impor01';
import global_axios from '../../funciones_globales/interaccionapi';
import { get_FechaLocalActual } from '../../funciones_globales/utils';
import { cargarCatalogos_Otros, cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import styled from 'styled-components';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { formatearLabel } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';


const ContenedorBotonAdd = styled.div`
    padding-top: 20px;
    @media (max-width: 991px) {
    padding: 0px;
    }
`;

const validate = values => {
    const errors = {}
    if (!values.cod_gasto) {
      errors.cod_gasto = 'El campo es obligatorio'
    }
    if (!values.tipo_gasto) {
        errors.tipo_gasto = 'El campo es obligatorio'
      }
    if (!values.observacion) {
        errors.observacion = 'El campo es obligatorio'
    } 
    if (!values.valor) {
    errors.valor = 'El campo es obligatorio'
    } 
    return errors
}

class FormImport01 extends React.Component{
    constructor(props){
        super(props);
            this.state = {             
                codigo_importacion: '',   
                gastos: [],
                importacion: null,
                gastos_import_detalles: [],              
                tiposgasto: [],
                tablaRubro: [],
                gridOptions: {
                    context: {
                        componentParent: this
                    }
                  },           
                columnDefs: [   
                                {   header: "Movimiento",
                                    field: "movimiento",
                                    width: 80,
                                    type: "string"
                                },
                                {   header: "Fecha",
                                    field: "fecha",
                                    width: 70,
                                    type: "fecha"
                                },
                                {   header: "Codigo",
                                    field: "CodigoGasto",
                                    width: 50,
                                    type: "string"
                                },
                                {   header: "Descripción",
                                    field: "descripcion",
                                    width: 450,
                                    type: "string"                       
                                },
                                {   header: "Valor",
                                    field: "valor",
                                    width: 100,
                                    type: "num_decimal"                        
                                },
                                {   header: "Diario",
                                    field: "diario",
                                    width: 95,
                                    type: "string"                                                
                                },
                                {   header: "",
                                    field: "eliminar",
                                    width: 50,
                                    type: "link_elim"                                                
                                }
                            ]
            };   
            
            this.validarAdd = this.validarAdd.bind(this);
        }


    submit(e){
        e.importacion = this.state.codigo_importacion;

        if(e.importacion){
            var data = {};
            data.importacion = this.state.codigo_importacion;
            data.fecha = e.fecha =  get_FechaLocalActual();
            data.localidad = e.localidad = '01';
            data.cod_gasto = e.cod_gasto = e.cod_gasto.trim();
            data.status = e.status = 'A'; //A=>ACTIVO; I=>INACTIVO
            data.valor = parseFloat(this.props.valor);
            data.observacion = this.props.observacion;
            data.tipo_gasto = this.props.tipo_gasto; //SE ENVIA EL CODIGO
            data.usuario = e.usuario = getItemDatosSesion('usuario').toString();

            let config_request = {
                method: 'POST',
                url: '/importaciones/'+ this.state.codigo_importacion.toString() + '/gastosimportacion',
                data
            }
            
            global_axios(config_request)
            .then((response)=>{
                alert('El gasto se registró correctamente.');
                this.props.cargar_GastosImportacion(this.state.codigo_importacion).then(()=>{
                    var importacion = this.props.gastos_import_detalles
                    
                    if(importacion.detImpGasto.length===0){
                        alert("Importación sin gastos");
                        this.setState({importacion: importacion})
                    }else{
                        this.setState({gastos_import_detalles: importacion.detImpGasto,
                            importacion: importacion});
                    }
                });           
            }) 
            .catch((error)=>{                
                if (error.response){
                   alert(error.response.data.msg);
                }
            })

        }else{
            alert("Imposible ingresar gasto sin seleccionar una importacion")
        }
        
    }

    getGastosImportacion(e){        
        if(this.props.codigo_importacion !== undefined && this.props.codigo_importacion !== ''){
            let codigo_import = this.props.codigo_importacion.value;

            this.props.cargar_GastosImportacion(this.props.codigo_importacion.value).then(()=>{
                var importacion = this.props.gastos_import_detalles
                
                if(importacion.detImpGasto.length===0){
                    alert("Importación sin gastos");
                    this.setState({codigo_importacion: codigo_import, importacion: importacion})
                }else{
                    this.setState({codigo_importacion: codigo_import,
                        gastos_import_detalles: importacion.detImpGasto,
                        importacion: importacion});
                }

                if(importacion.Status==='C'){
                    alert("No es posible modificar la importacion #:"+this.state.codigo_importacion+" tiene la compra #:"+importacion.Compra+" asignada")
                }
            });          
        }else{
            alert('No ha seleccionado importación');  
        }
    }

    methodFromParent(id, datos_fila) {        
        var mensaje = window.confirm("¿Desea eliminar el registro?"); 

        if (mensaje){
            this.eliminar(datos_fila ) 
        } 
    }

    componentDidMount(){
        Promise.all([  
            cargarCatalogos_Otros('IMP-TIPOGASTO'),
            this.cargarCatalogos_OtrosRubros('IMP-RUBROGASTO'),
            this.props.generar_LogAuditoriaIngresoForm('0301')
        ])
        .then(([result_gastos, result_rubros]) => {
            this.setState(
                { tiposgasto: result_gastos, gastos: result_rubros })
        })
        .catch(err => {
            console.log(err);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0301');
    }

    cargarCatalogos_OtrosRubros(tipo) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{                
                this.setState({tablaRubro: response.data})
                resolve(response.data.map(item => ({value: item.Codigo.toString().trim().toUpperCase(), label: `${item.Descripcion.toString().trim().toUpperCase()} (${item.Codigo.toString().trim().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
    
    eliminar(datos_fila){        
        if(datos_fila.Tipo !=='D' && datos_fila.Tipo !=='A' && datos_fila.Tipo !=='I'){
            var e = {};
            e.localidad = '01';
            e.secuencia = datos_fila.movimiento;
            e.valor = datos_fila.valor;
            e.importacion = this.state.codigo_importacion.toString();
            e.codigoGasto = datos_fila.CodigoGasto;
            e.conMovimiento = datos_fila.diario;

            let config_request = {
                method: 'PUT',
                url: '/importaciones/' + this.state.codigo_importacion.toString() + '/gastosimportacion/' +e.secuencia ,
                data:e
            };

            if(this.state.importacion.Status==='P'){
                global_axios(config_request)
                .then((response)=>{            
                    if(response){
                        alert(response.data.msg);
                        this.props.cargar_GastosImportacion(this.state.codigo_importacion).then(()=>{
                            var importacion = this.props.gastos_import_detalles                         
                            if(importacion.detImpGasto.length===0){
                                alert("Importación sin gastos.");
                                this.setState({importacion: importacion, gastos_import_detalles: []});
                            }else{
                                this.setState({gastos_import_detalles: importacion.detImpGasto,
                                        importacion: importacion});
                            }
                        });   
                    }
                }) 
                .catch(function(error){
                    if(error.response){
                        alert(error.response.data.msg);
                    }
                })
            }else{
                alert('La importación: '+this.state.codigo_importacion+' tiene asignada la compra: '+this.state.importacion.Compra+' ,no es posible modificar');
            }
        }else{
            alert("No pueden eliminarse gastos automaticos")
        }
    }
    
    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    tipoGastoAuto(e){
    
        var tipo_gasto = {};
        var cod_gasto = "";
        var gastoLabel = "";
      
        if(this.props.cod_gasto!==undefined && this.props.cod_gasto!==''){
                     
            if(this.props.cod_gasto.value!==undefined){
                cod_gasto = this.props.cod_gasto.value;
                gastoLabel = formatearLabel(this.props.cod_gasto.label);
            }else{
                cod_gasto = this.props.cod_gasto;
            }
            

            this.state.tablaRubro.forEach((DATA)=>{
                if(cod_gasto.toString().trim() === DATA.Codigo.toString().trim()){
                    tipo_gasto = {Tipo: DATA.Tipo.toString().trim()}; //Tipo
                }
            })

            for(var i = 0; i < this.state.tiposgasto.length; i++){
                if(tipo_gasto.Tipo === this.state.tiposgasto[i].value){
                    tipo_gasto = this.state.tiposgasto[i]; //Tipo
                }
            }
            
            var observacion = "";
            observacion = formatearLabel(tipo_gasto.label);
            this.props.change('tipo_gasto', tipo_gasto.value)
            this.props.change('observacion', observacion+' '+gastoLabel);
        }
        
    }

    validarAdd(){
        if(this.state.importacion === null){
            return true;
        }else{
            if(this.state.importacion.Status==='P'){
                return false;
            }else{
                return true
            }
        }
    }

    validacionDecimales(){
        var valor = this.props.valor
        if(isNaN(valor)===true){
            this.props.change('valor', '');
        }else{
            this.props.change('valor', valor);
        }
    }

    render(){
        const { handleSubmit, submitting } = this.props
        return(
            <ContenedorForm porc_ancho={70}>
            <HeaderForm>
                <TituloForm>Mantenimiento de Gastos de Importación</TituloForm>
            </HeaderForm>
                <CuerpoForm>                    
                    <ContainerEdit>
                        <Row>
                            <div className='col-md-6'>
                                <Field
                                    label="Importación:"
                                    name="importacion"
                                    component={ FieldBusqEspecifica }
                                    loadOptions={this.getOptions_Importaciones.bind(this)}
                                    getItemEspecifico={this.getGastosImportacion.bind(this)}
                                    textoBoton="Sel."
                                    icono="fa fa-check-circle-o"/>
                            </div>
                            <div className='col-md-3 col-md-offset-3'>
                                <br/>
                                <Label>Importación seleccionada: {+ this.state.codigo_importacion}</Label>
                            </div>
                        </Row>       
                    </ContainerEdit>
                        <form onSubmit={handleSubmit(this.submit.bind(this))}>
                            <Row>
                                <div className='col-md-3'>
                                    <Field
                                        name="cod_gasto"
                                        component={ FieldSelect }
                                        label="Codigo del gasto:"
                                        options={this.state.gastos}
                                        onBlur={this.tipoGastoAuto.bind(this)}/>          
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="tipo_gasto"
                                        component={ FieldSelect }
                                        label="Tipo:"
                                        options={this.state.tiposgasto}
                                        disabled={true}
                                        />                           
                                </div>
                                <div className='col-md-4'>
                                    <Field
                                        name="observacion"                                   
                                        component={ FieldGenerico }
                                        label="Observación:"/>                             
                                </div>
                                <div className='col-md-2'>
                                    <Field
                                        name="valor"    
                                        type="text"                               
                                        component={ FieldGenerico }
                                        label="Valor:"
                                        func_OnBlur={this.validacionDecimales.bind(this)}/>                                        
                                </div>
                                <div className='col-md-1'>
                                    <ContenedorBotonAdd>
                                        <button type="submit" className='btn btn-success btn-sm' disabled={this.validarAdd()}><i className="fa fa-plus" disabled={submitting}></i></button>
                                    </ContenedorBotonAdd>
                                </div>                                                
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <AgGridRender altura='240px' data={this.state.gastos_import_detalles} columnas={this.state.columnDefs} gridOptions={this.state.gridOptions}/>                                                           
                                </div>
                            </Row>                           
                        </form>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const selector = formValueSelector('form_impor01');

FormImport01 = reduxForm({
    form: 'form_impor01', enableReinitialize: true, validate
})(FormImport01)

FormImport01 = connect(  
    state => ({
        initialValues: state.inicializacion_form.data,
        codigo_importacion: selector(state, 'importacion'),
        gastos_import_detalles: selector(state, 'gastos_import_detalle'),

        valor: selector(state, 'valor'),
        observacion: selector (state, 'observacion'),
        tipo_gasto: selector(state, 'tipo_gasto'),
        cod_gasto: selector(state, 'cod_gasto')
    }),
    { cargar_GastosImportacion, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }
)(FormImport01)

export default FormImport01;
